import Component from "../abstracts/Component";


export default class EditorialLayoutComponent extends Component {

    get SELECTORS() {
        return {
            main: '.c-editorial-layout',
            translateYOnEnterInViewPortRow: '.row.translateY-on-enter-in-viewport',
        }
    }

    //method used to fill the gap between images from the fourth one onwards
    translateRowsOnYAxis() {
        let rows = $(`${this.SELECTORS.main} ${this.SELECTORS.translateYOnEnterInViewPortRow}:nth-child(n + 4)`);
        let translation = 100;
        rows.each(function (index, row) {
            let currentTranslation = index % 2 === 0 ?  60 : 100;
            let gapBetweenImages = translation - currentTranslation;
            let newTranslation = gapBetweenImages + 40;

            $(row).css('transform', `translateY(-${newTranslation}px`);
            
            translation = currentTranslation + newTranslation;
        });

    }

    render() {
        if(this.$matchMedia(null, 'md'))
            this.translateRowsOnYAxis();
    }
}